import PageHeader from '../molecules/PageHeader';
import SectionHeader from '../../components/atoms/SectionHeader';
import Button from '../../components/atoms/Button';
import { TextField } from '@mui/material';
import SettingRow from '../molecules/SettingRow';
import MessageBar from '../atoms/MessageBar';

const SettingsLayout = ({ changePasswordHandler, msg, msgType }) => {
  return (
    <div>
      <PageHeader>Settings</PageHeader>

      <div className=' my-5'>
        <SectionHeader>Change Password</SectionHeader>

        <SettingRow
          label='Current Password'
          InputComponent={TextField}
          id='current_password'
          fullWidth
          defaultValue=''
          type='password'
        />

        <SettingRow
          label='New Password'
          InputComponent={TextField}
          id='new_password'
          fullWidth
          defaultValue=''
          type='password'
        />

        <SettingRow
          label='New Password Again'
          InputComponent={TextField}
          id='new_password_again'
          fullWidth
          defaultValue=''
          type='password'
        />

        <SettingRow
          label='&nbsp;'
          InputComponent={Button}
          children='Save'
          callback={changePasswordHandler}
        />

        <SettingRow
          label='&nbsp;'
          InputComponent={MessageBar}
          msg={msg}
          type={msgType}
        />
      </div>
    </div>
  );
};

export default SettingsLayout;
